
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-10 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-neon-purple/10 to-neon-blue/10 backdrop-blur-sm -z-10"></div>
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 animate-fade-in">Ready to take your music career to the next level?</h2>
        <p className="text-white/80 mb-6 text-lg animate-fade-in" style={{ animationDelay: "0.1s" }}>
          Join thousands of independent musicians who are using Muso360 to manage their careers.
        </p>
        <Button 
          variant="cyber" 
          size="lg" 
          className="animate-fade-in group"
          style={{ animationDelay: "0.2s" }}
          onClick={() => navigate('/auth/signup')}
        >
          Start Your Journey Now
          <ArrowRight className="ml-1 group-hover:translate-x-1 transition-transform duration-200" />
        </Button>
      </div>
    </section>
  );
};

export default CTASection;
